import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "bi-tmpl-detail__right__cmpt" }
const _hoisted_2 = { class: "bi-tmpl-detail__right__cmpt__title" }
const _hoisted_3 = {
  key: 0,
  class: "bi-tmpl-detail__right__cmpt__tips"
}
const _hoisted_4 = { class: "bi-tmpl-detail__right__cmpt__des" }

import PcModuleTaskAnalysis from '@V/bi-tmpl/src/components/bi-pc-module/pc-module-task-analysis';

import { BaseCard } from 'xrk-components';
import { BaseRadio } from 'xrk-components';
import { Carousel } from '@/components/base/carousel';
import { useDetailCmpt } from '@V/bi-tmpl/src/hooks';
import _ from 'lodash';
import { data_4_3 } from '../../../../hooks/use-preview';

const CHILD_KEY = '5_4';

export default /*#__PURE__*/_defineComponent({
  __name: 'bi-tmpl-detail-5-4',
  setup(__props) {

const TYPE_MAPPING = {
  1: {
    value: 'pc-module-task-analysis-1',
    moduleType: 'pc-module-task-analysis-1'
  },
  2: {
    value: 'pc-module-task-analysis-2',
    moduleType: 'pc-module-task-analysis-2'
  },
  3: {
    value: 'pc-module-task-analysis-3',
    moduleType: 'pc-module-task-analysis-3'
  },
  4: {
    value: 'pc-module-task-analysis-4',
    moduleType: 'pc-module-task-analysis-4'
  },
  5: {
    value: 'pc-module-task-analysis-5',
    moduleType: 'pc-module-task-analysis-5'
  },
  6: {
    value: 'pc-module-task-analysis-6',
    moduleType: 'pc-module-task-analysis-6'
  }
};

const { curItem, onChange } = useDetailCmpt({ childKey: CHILD_KEY });
const cmpName = name => {
  return PcModuleTaskAnalysis.filter(comp => comp.__name === name)[0];
};
const onChangeFn = _.debounce(val => {
  if (curItem.value === val) {
    onChange(null);
  } else {
    onChange(val);
  }
}, 0);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(curItem).title), 1),
      (_unref(curItem).tips)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref(curItem).tips), 1))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_unref(Carousel), {
      ref: "carouselRef",
      itemHeight: 130,
      itemWidth: 420 + 56
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(TYPE_MAPPING, (item, index) => {
          return _createElementVNode("div", {
            style: {"text-align":"center"},
            key: index
          }, [
            _createVNode(_unref(BaseCard), { style: {"width":"420px","height":"120px"} }, {
              default: _withCtx(() => [
                _createVNode(_unref(BaseRadio), {
                  class: "bi-tmpl-detail__right__cmpt__radio bi-tmpl-detail__right__cmpt__radio--w",
                  style: {"height":"86px !important"},
                  value: item.value,
                  "model-value": _unref(curItem).value,
                  onChange: ($event: any) => (_unref(onChangeFn)(item.value))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(cmpName(item.value)), {
                      style: {"width":"1200px","transform":"scale(0.32)","transform-origin":"center 0"},
                      tableHeaderList: _unref(data_4_3).medianTable.header,
                      tableDataList: _unref(data_4_3).medianTable.value
                    }, null, 8, ["tableHeaderList", "tableDataList"]))
                  ]),
                  _: 2
                }, 1032, ["value", "model-value", "onChange"])
              ]),
              _: 2
            }, 1024)
          ])
        }), 64))
      ]),
      _: 1
    }, 512),
    _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(data_4_3).resultSystemMedian), 1)
  ]))
}
}

})